export default "__VITE_ASSET__BrGIZQ$c__"